import { useFeedStore } from '@modules/feed/store/feedStore';
import { FeedActionType } from '@modules/feed/store/searchActionType';
import { QueryBuilder } from '@modules/queryBuilder/components/QueryBuilder';
import { trackQBEvent } from '@modules/queryBuilder/events';
import { QueryBuilderStoreProvider } from '@modules/queryBuilder/store/QueryBuilderStoreProvider';
import { QueryOnChangeProps } from '@modules/queryBuilder/types';
import { Stack, Typography } from '@mui/material';
import { createAnalyticsTracker } from 'v2/analytics/events';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';
import { mapToEQL } from 'v2/core/repository/eql/mappers';
import { ExpressionType } from 'v2/core/repository/eql/types';

export const trackSearchV2Events = createAnalyticsTracker('searchV2');

export function BasicSearchDropdownV2() {
  const dispatch = useFeedStore(({ dispatch }) => dispatch);
  const { data: sourceDetailsMap } = useGetSourceDetailsMap();

  const onExecute = ({ whereClause }: QueryOnChangeProps) => {
    dispatch({
      type: FeedActionType.SET_QUERY,
      payload: {
        whereClause,
      },
    });

    trackQBEvent({
      eventName: 'Query Builder Action Event',
      action: {
        type: 'EXECUTE_QUERY',
        eql: mapToEQL({
          whereClause,
          expressionType: ExpressionType.Records,
          sourceDetailsMap: sourceDetailsMap ?? new Map(),
        }),
        display: '',
        searchMetadata: '',
        qbContext: 'Home',
      },
    });
  };

  return (
    <Stack direction="column" spacing={1.5} width="100%" position="relative">
      <Typography variant="h4">Find Customer Feedback</Typography>
      <QueryBuilderStoreProvider>
        <QueryBuilder
          onExecute={onExecute}
          forceEnableExecuteButton={true}
          autoFocus
          openOnFocus={false}
        />
      </QueryBuilderStoreProvider>
    </Stack>
  );
}
